import Autocomplete from '@betterfunnel/ui-core/Autocomplete';
import { useEffect, useState } from 'react';
import { classNames } from '../../utils';

interface Props<T> {
  title?: string;
  editable?: boolean;
  selected: T | null;
  getValue: (c: T) => string;
  getOptionId?: (c: T) => string;
  setSelected?: (selected: T | null) => void;
  options: T[];
  update: () => void;
}

export default function SettingSectionAutocomplete<T>({
  title,
  editable,
  selected,
  getValue,
  getOptionId,
  setSelected,
  options,
  update,
}: Props<T>) {
  const [editing, setEditing] = useState(false);
  const [initialValue, setInitialValue] = useState<T | null>(selected);

  useEffect(() => {
    if (editing) {
      setInitialValue(selected);
    }
  }, [editing]);

  return (
    <div className="pt-6 sm:flex sm:flex-wrap sm:items-center">
      <dt className="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">
        {title}
      </dt>
      <dd className="mt-1 flex flex-wrap items-start justify-between gap-2 gap-x-6 sm:mt-0 sm:flex-auto">
        {!editing ? (
          <div className="flex flex-wrap gap-2">
            <div
              className={classNames(
                'text-sm',
                selected ? 'text-gray-900' : 'mt-1 text-gray-500',
              )}
            >
              {selected ? getValue(selected) : 'None Selected'}
            </div>
          </div>
        ) : (
          <Autocomplete
            getValue={getValue}
            selected={selected || undefined}
            onChange={(s) => {
              setSelected?.(s);
            }}
            // onInputChange={(t) => setQuery(t)}
            getOptionId={getOptionId}
            options={options}
          />
        )}
        <div className="flex gap-4">
          {editing ? (
            <button
              type="button"
              className="font-semibold text-gray-600 hover:text-gray-500"
              onClick={() => {
                setSelected?.(initialValue);
                setEditing((a) => !a);
              }}
            >
              Cancel
            </button>
          ) : (
            <></>
          )}
          {editable ? (
            <button
              type="button"
              className="font-semibold text-indigo-600 hover:text-indigo-500"
              onClick={() => {
                setEditing((a) => !a);
                if (editing) {
                  update();
                }
              }}
            >
              {editing ? 'Save' : 'Edit'}
            </button>
          ) : (
            <></>
          )}
        </div>
      </dd>
    </div>
  );
}
